import { useState, useEffect } from "react";
import { queryDoctorsWithProcessingNotes, queryDoctorsWithPlgStatus, getNewDoctorsThisWeek } from "../../utils/functions";
import ProcessingNotesList from "./HomeWidgetInteractions/ProcessingNotesList";
import PLGUsersList from "./HomeWidgetInteractions/PLGUsersList";
import NewUsersList from "./HomeWidgetInteractions/NewUsersList";
import PercentageIndicator from "./PercentageIndicator";

export default function HomeWidget({ displayText, displayArray = null, variableProp, asyncFunction, appendS = false, helperScript }) {
  const [valueProp, setValueProp] = useState(null);
  const [helperData, setHelperData] = useState(null);
  const [openModal, setOpenModal] = useState("");
  const [multiValues, setMultiValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Handle multi-display case
        if (displayArray && displayArray.length > 0) {
          setIsLoading(true);
          const result = await asyncFunction();
          setMultiValues(result);
          setIsLoading(false);
        }
        // Handle single-display case
        else if (asyncFunction && valueProp === null) {
          const result = await asyncFunction();
          setValueProp(result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (helperScript !== "Processing") return;

    const fetchProcessingData = async () => {
      try {
        const result = await asyncFunction();
        setValueProp(result);
      } catch (error) {
        console.error("Error fetching processing data:", error);
      }
    };

    const intervalId = setInterval(fetchProcessingData, 3000);

    return () => clearInterval(intervalId);
  }, [helperScript, asyncFunction]);

  const executeHelperFunction = async (e) => {
    e.preventDefault();

    if (helperScript === "Processing") {
      setHelperData(await queryDoctorsWithProcessingNotes());
      setOpenModal("Processing");
    } else if (helperScript === "PLG Users") {
      setHelperData(await queryDoctorsWithPlgStatus());
      setOpenModal("PLG Users");
    } else if (helperScript === "active") {
      setHelperData(await getNewDoctorsThisWeek("active", true));
      setOpenModal("active");
    } else if (helperScript === "inactive") {
      setHelperData(await getNewDoctorsThisWeek("inactive", true));
      setOpenModal("inactive");
    }
  }

  const handleDisabledButton = () => {
    return !(helperScript === "Processing" || helperScript === "PLG Users");
  }

  if (displayArray && displayArray.length > 0) {
    return (
      <>
        {displayArray.map((display, index) => (
          <div
            key={index}
            className="shadow-knowtex-shadow p-4 rounded-md w-[20%] flex flex-col items-center justify-center relative"
          >
            <h4 className="font-semibold text-ktx-navy">{display}</h4>
            {isLoading ? (
              <div className="w-6 h-6 border-2 border-dashed rounded-full animate-spin border-ktx-purple"></div>
            ) : (
              <>
                <h3 className="text-sage-green text-[24px] font-semibold">
                  {display === "Mobile Notes" ? multiValues.current?.jobsWithoutConversationId : multiValues.current?.jobsWithConversationId}
                </h3>
                {display === "Mobile Notes" ? <PercentageIndicator percentage={multiValues.percentChange?.mobile} /> : <PercentageIndicator percentage={multiValues.percentChange?.webApp} />}
              </>
            )}
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      {asyncFunction ? (
        <div className="shadow-knowtex-shadow p-4 rounded-md w-[20%] flex flex-col items-center justify-center">
          <h4 className="font-semibold text-ktx-navy">{displayText}</h4>
          {valueProp !== null && valueProp !== undefined ? (
            helperScript === "Processing" || helperScript === "PLG Users" || helperScript === "active" || helperScript === "inactive" ? (
              <button onClick={executeHelperFunction}>
                <h3 className="text-sage-green text-[24px] font-semibold">
                  {!appendS ? valueProp : `${valueProp.toFixed(2)}s`}
                </h3>
              </button>
            ) : (
              <h3 className="text-sage-green text-[24px] font-semibold">
                {!appendS ? valueProp : `${valueProp.toFixed(2)}s`}
              </h3>
            )
          ) : (
            <div className="w-6 h-6 border-2 border-dashed rounded-full animate-spin border-ktx-purple"></div>
          )}
          {openModal === "Processing" && <ProcessingNotesList helperData={helperData} setOpenModal={setOpenModal} />}
          {openModal === "PLG Users" && <PLGUsersList helperData={helperData} setOpenModal={setOpenModal} />}
          {openModal === "active" && <NewUsersList helperData={helperData} setOpenModal={setOpenModal} />}
          {openModal === "inactive" && <NewUsersList helperData={helperData} setOpenModal={setOpenModal} />}

          {/* TODO: comparison for last week <span></span> */}
        </div>
      ) : (
        <div className="shadow-knowtex-shadow p-4 rounded-md w-[20%] flex flex-col items-center justify-center">
          <h4 className="font-semibold text-ktx-navy">{displayText}</h4>
          {variableProp !== null ? <h3 className="text-sage-green text-[24px] font-semibold">{variableProp}</h3> : <div className="w-6 h-6 border-2 border-dashed rounded-full animate-spin border-ktx-purple"></div>}
          {/* TODO: comparison for last week <span></span> */}
        </div>
      )}
    </>
  )

}